<template>
  <ion-page>
    <ion-tabs @ionTabsWillChange="beforeTabChange" @ionTabsDidChange="afterTabChange">
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="checkmarkCircleOutline" href="/new-request/D">
          <ion-icon :icon="checkmarkCircleOutline"></ion-icon>
          <ion-label>확인대기</ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="checkmarkDoneOutline" href="/new-request/B">
          <ion-icon :icon="checkmarkDoneOutline"></ion-icon>
          <ion-label>확인전</ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="checkmarkDoneCircleOutline" href="/new-request/Y">
          <ion-icon :icon="checkmarkDoneCircleOutline"></ion-icon>
          <ion-label>확인완료</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="schedule" href="/new-request/N">
          <ion-icon :icon="closeCircleOutline"></ion-icon>
          <ion-label>재확인</ion-label>
          <!-- <ion-badge>6</ion-badge> -->
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
    <ion-fab vertical="bottom" horizontal="center" slot="fixed">
      <ion-fab-button @click="setFilter">
        <ion-icon :icon="funnelOutline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    
    <ion-modal
      :is-open="isOpenRef"
      css-class="my-custom-class"
      @didDismiss="setOpenClose(false)"
    >
      <FilterModal :title="detailTitle" :modal-data="detailData" :chg-dv="chgDv" @close="setOpenClose"></FilterModal>
    </ion-modal>
  </ion-page>
</template>

<script>
  import { defineComponent, ref, reactive, inject, onMounted } from 'vue'
  import { 
    IonIcon, 
    IonLabel, 
    IonPage, 
    IonTabBar, 
    IonTabButton, 
    IonFabButton, 
    IonTabs, 
    IonModal 
  } from '@ionic/vue'
  import { checkmarkCircleOutline, checkmarkDoneOutline, checkmarkDoneCircleOutline, closeCircleOutline, funnelOutline } from 'ionicons/icons'
  import FilterModal from '@/components/modal/FilterModal'

  export default defineComponent({
    components: {
      IonIcon,
      IonLabel,
      IonPage,
      IonTabBar,
      IonTabButton,
      IonFabButton,
      IonTabs,
      IonModal,
      FilterModal
    },
    setup() {
      const eventBus = inject('$eventBus')
      const isOpenRef = ref(false)
      const setOpenClose = (state) => isOpenRef.value = state
      let chgDv = ref('신규신청')

      let detailTitle = '검색'
      let detailData = reactive({})

      onMounted(() => {
        eventBus.on('filter', val => {
          chgDv.value = val
        })
      })      

      const beforeTabChange = () => {
        // do something before tab change
      }
      
      const afterTabChange = () => {
        // do something after tab change
      }

      const setFilter = () => {
        setOpenClose(true)
      }

      return {
        isOpenRef, 
        setOpenClose,
        checkmarkCircleOutline,
        checkmarkDoneOutline,
        checkmarkDoneCircleOutline,
        closeCircleOutline,
        funnelOutline,
        beforeTabChange,
        afterTabChange,
        setFilter,
        detailTitle,
        detailData,
        chgDv
      }
    }
  })
</script>

<style scoped>
:deep ion-fab{
  bottom: 30px;
}
:deep ion-content::after{
  position: absolute;
  width: 100%;
  height: 60px;
  background-image: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.7));
  /* background-image: linear-gradient(rgba(255,0,0,0), rgba(255,0,0,0.5)); */
  bottom: 0;
  content: '';
}
</style>